import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { defaultCardImg, discoverCardMiniImg, masterCardMiniImg, visaCardMiniImg } from '../../const/assets';
import MainContext from '../../Context';
import { MiniCard } from './MiniCard';
const ImageForCardNumberInput = ({ firstCardNumber }) => {
    const validFirstCardNumber = [
        [5, 'MASTERCARD'],
        [4, 'VISA'],
        [6, 'DISCOVER']
    ];
    const { staticHostName } = useContext(MainContext);
    /**
     * Valid first card numbers:
     * Mastercard -  5
     * Visa - 4
     * Discover - 6
     */
    const [, cardVendor] = validFirstCardNumber.find(([firstCardNum]) => firstCardNum === Number(firstCardNumber)) || [undefined, 'DEFAULT'];
    const CardComponents = {
        VISA: (_jsx(MiniCard, { alt: "", ariaHidden: true, testId: "visamini", url: `${staticHostName}${visaCardMiniImg}` })),
        MASTERCARD: (_jsx(MiniCard, { alt: "", ariaHidden: true, testId: "mastercardmini", url: `${staticHostName}${masterCardMiniImg}` })),
        DISCOVER: (_jsx(MiniCard, { alt: "", ariaHidden: true, testId: "discovermini", url: `${staticHostName}${discoverCardMiniImg}` })),
        DEFAULT: (_jsx(MiniCard, { alt: "", ariaHidden: true, testId: "carddefault", url: `${staticHostName}${defaultCardImg}` }))
    };
    return CardComponents[cardVendor];
};
export default ImageForCardNumberInput;
